const revealElements = document.querySelectorAll('[data-reveal]');

if (revealElements.length) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const delay = parseInt(el.dataset.revealDelay, 10) || 0;

                    if (delay) {
                        el.style.transitionDelay = `${delay}ms`;
                    }

                    el.classList.add('is-revealed');
                    observer.unobserve(el);
                }
            });
        },
        { threshold: 0.15, rootMargin: '0px 0px -50px 0px' },
    );

    revealElements.forEach((el) => {
        // Stagger: auto-assign delays to children with [data-reveal-child]
        const children = el.querySelectorAll('[data-reveal-child]');
        const baseDelay = parseInt(el.dataset.revealStagger, 10) || 100;
        children.forEach((childEl, i) => {
            childEl.style.setProperty('transition-delay', `${i * baseDelay}ms`);
        });

        observer.observe(el);
    });
}
